const apiUrl = process.env.REACT_APP_API_URL;
export const PutJutgePracticaIdDocumentId = async (id_document: any, json: any) => {
    if (!id_document || id_document === "undefined" || id_document === 0) {
        console.error("PutJutgePracticaIdDocumentId: invalid id_document", id_document);
        throw new Error(`ID de document invàlid: ${id_document}`);
    }
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/document/${id_document}`,
            {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(json)
            });
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.log('Error al obtener los datos:', error);
        throw error;
    }
};
